import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  count: 0,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_COMMUNITY_ONLINE_USER_COUNT:
      return { ...state, isLoading: true };
    case types.RECEIVE_COMMUNITY_ONLINE_USER_COUNT_ERROR:
      return {
        ...state, isLoading: false, error: true, count: 0,
      };
    case types.RECEIVE_COMMUNITY_ONLINE_USER_COUNT_RESPONSE:
      return {
        ...state, isLoading: false, error: false, count: action.payload,
      };
    default:
      return state;
  }
}
